<template lang="pug">
  .countries
    .section
      .container.has-text-centered
        h1 {{ gettext('Countries') }}
          .dotted-line.left
          .dotted-line.right
        .field.is-horizontal
          label.label {{ gettext('Choose country:') }}
          .field-body
            dropdown-countries(
            :itemName ="'name'",
            :itemValue="'link'",
            :countries="countries"
            @selected="goToCountry"
            )
        .blocks-wrap
          .column(v-for="(country, key) in countries")
            router-link.img-wrap(:to="{name: 'Country', params: {lang: getLanguage, country: country.link}}")
              .overlay
              .img-bg(v-if="country.img" :style="{ 'background-image': 'url(' + country.img + ')'}")
              .img-bg(v-else)
              span {{ country.name }}
        .field.is-horizontal
          .field-body
            .main-btn.bg-transparent(@click="more = !more" v-if="allCountries.length > countriesLimit") {{ !more ? gettext('Show more') : gettext('Show less') }}
</template>

<script>
import {mapGetters} from 'vuex'
import {gettext} from './../../services/TranslateHandler'
import AjaxDropdown from '@/components/ajax-dropdown'
import DropdownCountries from './components/dropdown-countries'
import mixin from '@/mixins'

export default {
  name: 'Countries',
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  components: {
    AjaxDropdown,
    DropdownCountries
  },
  methods: {
    gettext: gettext,
    goToCountry (link) {
      this.$router.push({name: 'Country', params: {lang: this.getLanguage, country: link}})
    },
    setAllCountries () {
      this.allCountries = [
        {
          link: 'austria',
          img: '/webapp/images/countries/austria-min.png',
          name: gettext('Austria')
        },
        {
          link: 'belgium',
          img: '/webapp/images/countries/belgium-min.png',
          name: gettext('Belgium')
        },
        {
          link: 'germany',
          img: '/webapp/images/countries/germany-min.png',
          name: gettext('Germany')
        },
        {
          link: 'denmark',
          img: '/webapp/images/countries/denmark-min.png',
          name: gettext('Denmark')
        },
        {
          link: 'latvia',
          img: '/webapp/images/countries/latvia-min.png',
          name: gettext('Latvia')
        },
        {
          link: 'lithuania',
          img: '/webapp/images/countries/lithvenia-min.png',
          name: gettext('Lithuania')
        },
        {
          link: 'netherlands',
          img: '/webapp/images/countries/holland-min.png',
          name: gettext('Netherlands')
        },
        {
          link: 'norway',
          img: '/webapp/images/countries/norway-min.png',
          name: gettext('Norway')
        },
        {
          link: 'poland',
          img: '/webapp/images/countries/poland-min.png',
          name: gettext('Poland')
        },
        {
          link: 'slovakia',
          img: '/webapp/images/countries/slovakia-min.png',
          name: gettext('Slovakia')
        },
        {
          link: 'finland',
          img: '/webapp/images/countries/finland-min.png',
          name: gettext('Finland')
        },
        {
          link: 'switzerland',
          img: '/webapp/images/countries/switzerland2-min.jpg',
          name: gettext('Switzerland')
        },
        {
          link: 'estonia',
          img: '/webapp/images/countries/estonia-min.png',
          name: gettext('Estonia')
        },
        {
          link: 'ukraine',
          img: '/webapp/images/countries/ukrine-min.png',
          name: gettext('Ukraine')
        },
        {
          link: 'kazakhstan',
          img: '/webapp/images/countries/kazakhstan-min.png',
          name: gettext('Kazakhstan')
        },
        {
          link: 'romania',
          img: '/webapp/images/countries/romania-min.png',
          name: gettext('Romania')
        },
        {
          link: 'kyrgyzstan',
          img: '/webapp/images/countries/kyrgystan-min.png',
          name: gettext('Kyrgyzstan')
        },
        {
          link: 'hungary',
          img: '/webapp/images/countries/hungary-min.png',
          name: gettext('Hungary')
        },
        {
          link: 'bosnia-and-herzegovina',
          img: '/webapp/images/countries/bosnia-min.png',
          name: gettext('Bosnia and Herzegovina')
        },
        {
          link: 'serbia',
          img: '/webapp/images/countries/serbia-min.png',
          name: gettext('Serbia')
        },
        {
          link: 'croatia',
          img: '/webapp/images/countries/croatia-min.png',
          name: gettext('Croatia')
        },
        {
          link: 'montenegro',
          img: '/webapp/images/countries/montenegro-min.png',
          name: gettext('Montenegro')
        },
        {
          link: 'macedonia',
          img: '/webapp/images/countries/macedonia-min.png',
          name: gettext('Macedonia')
        },
        {
          link: 'russia',
          img: '/webapp/images/countries/russia-min.png',
          name: gettext('Russia')
        },
        {
          link: 'belarus',
          img: '/webapp/images/countries/belorus-min.png',
          name: gettext('Belarus')
        }
        // {
        //   link: 'usa',
        //   img: '/webapp/images/countries/usa-min.png',
        //   name: gettext('USA')
        // },
        // {
        //   link: 'iceland',
        //   img: '/webapp/images/countries/iceland-min.png',
        //   name: gettext('Iceland')
        // },
        // {
        //   link: 'ireland',
        //   img: '/webapp/images/countries/ireland-min.png',
        //   name: gettext('Ireland')
        // },
        // {
        //   link: 'great-britain',
        //   img: '/webapp/images/countries/great-britain-min.png',
        //   name: gettext('Great Britain')
        // }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    },
    countries: function () {
      if (this.more) return this.allCountries
      return this.allCountries.slice(0, this.countriesLimit)
    }
  },
  data () {
    return {
      more: false,
      countriesLimit: 9,
      allCountries: []
    }
  },
  created () {
    this.setAllCountries()
    this.$emit('get_countries', (this.countries.name))
  }
}
</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/index.vue